export const AUDIO_EXTENSIONS = new Set([
  'mp3',
  'ogg',
  'opus',
  'wav',
  'm4a',
  'aac',
  'aiff',
  'aif',
]);

export const IGNORED_FILE_TYPES = new Set(['audio', 'embed']);
export const MEDIA_FILE_TYPES = new Set(['image', 'video', 'ig_reel']);

export const toUnixSeconds = createdAt => {
  if (!createdAt) return null;

  if (typeof createdAt === 'number') {
    return createdAt > 1e12 ? Math.floor(createdAt / 1000) : createdAt;
  }

  const parsedDate = new Date(createdAt);
  if (Number.isNaN(parsedDate.getTime())) return null;

  return Math.floor(parsedDate.getTime() / 1000);
};

export const isIgnoredGalleryAttachment = attachment => {
  const extension = (attachment.extension || '').toLowerCase();

  return (
    IGNORED_FILE_TYPES.has(attachment.file_type) ||
    AUDIO_EXTENSIONS.has(extension)
  );
};

export const isMediaAttachment = attachment =>
  MEDIA_FILE_TYPES.has(attachment.file_type);

export const normalizeAttachment = attachment => ({
  ...attachment,
  created_at: toUnixSeconds(attachment.created_at || attachment.createdAt),
});
